import Cookies from 'js-cookie';
import { ReactNode, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ADMIN, URole, USER } from '../constants/navigation';
import AuthContext from '../contexts/AuthContext';
import { getCookies, removeCookies } from '../utility/cookies';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData: user, accessToken } = useContext(AuthContext);

  const handleRedirect = (role: string) => {
    const menuItems = !!role && role === 'ADMIN' ? ADMIN : USER;
    const menuItem = menuItems?.find(item => item === location.pathname);
    if (menuItem) {
    } else {
      if (role === URole.COMPANY_ADMIN) {
        navigate('/token-management', { replace: true });
      } else if (role === URole.USER) {
        navigate('/wallet', { replace: true });
      }
    }
  };

  useEffect(() => {
    // If no token and not on login page, redirect to login
    if (
      !accessToken &&
      !['/login', '/admin-login'].includes(location.pathname)
    ) {
      console.log(location.pathname, 'local ');
      console.log(
        " Didn't found user so redirecting it to login",
        user,
        accessToken,
      );
      const role = getCookies('role');
      navigate(role === 'ADMIN' ? '/admin-login' : '/login');
      removeCookies('role');

      return;
    }
    // If already logged in, redirect to home or appropriate page based on role
    if (!!user && ['/login', '/admin-login'].includes(location.pathname)) {
      if (user?.role === URole.COMPANY_ADMIN) {
        navigate('/token-management', { replace: true });
      } else if (user?.role !== URole.USER) {
        navigate('/wallet', { replace: true });
      } else {
        handleRedirect(user?.role);
      }
    }
  }, [location.pathname, user, accessToken]);

  return <>{children}</>;
};

export default ProtectedRoute;
